import { Routes, Route } from 'react-router-dom';
import './App.css';
import OperatorRegister from './pages/OperatorRegister';
import Home from './pages/Home';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Available from './components/Available';
import EmailValidate from './pages/EmailValidate';
import VerifyEmail from './pages/verifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import Profile from './pages/Profile';
import Service from './pages/Service';
import ResetPassword from './pages/ResetPassword';
import Google from './pages/Google';
import Contact from './pages/Contact';
import { LanguageProvider } from './components/LanguajeContext';
import VerifyEmailclientPayment from './pages/verifyEmailclientPayment';
import Reservation from './pages/Reservation';
import { GoogleOAuthProvider } from '@react-oauth/google';
import OperatorReservations from './pages/OperatorReservations';
import Filosofia from './pages/FIlosofia';
import PaymentPageClient from './pages/PaymentPageClient';
import SubscriptionPlanPage from './pages/subscriptionPlanPage';
import CheckoutPage from './pages/CheckotuPage';
import PaymentServiceOnvo from './pages/PaymentServiceOnvo';
import PaymentSuccessReservation from './pages/PaymentSuccessReservation';
function App() {
  return (
    <GoogleOAuthProvider clientId="312865778710-19lsg74dtb55fkmqb0fed2j1c5ees1e2.apps.googleusercontent.com">
      <LanguageProvider>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/google" element={<Google />} />
          <Route path="/registro" element={<OperatorRegister />} />
          <Route path="/login" element={<Login />} />
          <Route path="/emailValidate" element={<EmailValidate />} />
          <Route path="/verify" element={<VerifyEmail />} />
          <Route path="/forgotPassword" element={<ForgotPassword />} />
          <Route path="/reservation/:id_service" element={<Reservation />} />
          <Route path="/PaymentServiceOnvo" element={< PaymentServiceOnvo/>} />
          <Route path="/reset-password?" element={< ResetPassword/>} />\
          <Route path="/nosotros" element={< Filosofia/>} />
          <Route path="/contacto" element={< Contact/>} />
          <Route path="/paymentClient" element={< PaymentPageClient/>} />
          <Route path="/suscription" element={< SubscriptionPlanPage/>} />
          <Route path="/payment-client/success" element={< PaymentSuccessReservation/>} />
          
             <Route path="/checkout" element={< CheckoutPage/>} />

          <Route path="/verify-client" element={< VerifyEmailclientPayment/>} />
          <Route path="/dashboard" element={<Dashboard />}>
            <Route path="available" element={<Available />} />
            <Route path="service" element={<Service />}/>
            <Route path="profile" element={<Profile />}/>
            <Route path="booking" element={<OperatorReservations />}/>
          </Route>
       
        </Routes>
      </div>

      </LanguageProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
